import moment from "moment";
import React from "react";
import * as Form from 'tsui/Form';
import { ApiMessage } from "../../../api/messages";
import PageDialog from "../../../tsui/PageDialog";


interface MessageDetailsTabProps {
    messageId: string;
    onClose: () => void;
}

export default function MessagesDetailsTab(props: MessageDetailsTabProps) {

    const [data, setData] = React.useState<ApiMessage | null>(null);
    const form = Form.useUpdateForm();

    const onSubmit = React.useCallback((evt: Form.InputFormEvent) => {
        // evt.data.accountId = props.messageId

        // Api.requestSession<any>('admin', 'update_account', evt.data).then(d => {
        //     // console.log(`modified count is ${d.modifiedCount}`)
        // }).catch(err => console.log(err));

        props.onClose();

    }, []);




    // return <Form.FormDataProvider<ApiMessage> apiGroup="messages" apiCommand="get" apiParams={{messageId:props.messageId}} onData={d => setData(d)} form={form}>
    return <Form.FormDataProvider<ApiMessage> apiGroup="messages" apiCommand="get" apiParams={{ messageId: props.messageId }} onData={d => setData(d)} form={form}>
        {/* <Form.DialogInputForm title='senderEmail' form={form} size='md' onSubmit={onSubmit} onClose={props.onClose}> */}
        <PageDialog title='User' form={form} size='md' onClose={props.onClose} type='confirm'>

            <Form.InputText label='Subject' id='subject' autocomplete='off' validate='off' readonly value={data?.subject} form={form} xs={7} />
            <Form.InputText label='Content' id='content' autocomplete='off' validate='off' readonly value={data?.content} form={form} xs={7} />
            {/* <Form.InputText label='Status' id='status' autocomplete='off' validate='off' readonly  value={data?.status} form={form} xs={7}/> */}
            <Form.InputText label='DateCreated' id='dateCreated' autocomplete='off' validate='off' readonly value={`${moment(data?.dateCreated).format("DD.MM.YYYY HH:mm")}`} form={form} xs={7} />
        </PageDialog>
        {/* </Form.DialogInputForm> */}
    </Form.FormDataProvider>
}


